import { assert } from './assert';

export function handler<TTarget>(
  target: TTarget,
  methodName: keyof TTarget,
  args: unknown[] = []) {

  const method = target[methodName];
  assert(typeof method === 'function',
    `'${String(methodName)}' is not a function.`);

  return (target[methodName] as (...args: unknown[]) => unknown).bind(target, ...args);
}
